import { createRoot } from 'react-dom/client'
import { HelmetProvider } from 'react-helmet-async'
import App from './App.tsx'
import './index.css'

// Load and initialize analytics off the critical path: dynamic imports keep
// @vercel/analytics and @vercel/speed-insights out of the eager entry chunk
// (nothing on first paint needs them), and we still wait for idle before
// running them so they never compete with rendering.
const initAnalytics = () => {
  void Promise.all([
    import('@vercel/analytics'),
    import('@vercel/speed-insights'),
  ]).then(([{ inject }, { injectSpeedInsights }]) => {
    inject();
    injectSpeedInsights();
  });
};

if (typeof requestIdleCallback !== 'undefined') {
  requestIdleCallback(initAnalytics);
} else {
  setTimeout(initAnalytics, 2000);
}

createRoot(document.getElementById("root")!).render(
  <HelmetProvider>
    <App />
  </HelmetProvider>
);
